import * as _ from 'lodash';
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IJobIssueMaterialItem extends IModel {
	vendorKey?: string;
	productName: string;
    poNumber?: string;
}

const jobIssueMaterialItemFactory = modelFactory.createFactory<IJobIssueMaterialItem>('JobIssueMaterialItem', _.assign({}, model, {
	vendorKey: {
		setFilters: valueFilters.toString
	},
	productName: {
		setFilters: valueFilters.toString,
		rules: validator.required()
	},
	poNumber: {
		setFilters: valueFilters.toString,
	}
}));

export default jobIssueMaterialItemFactory;